import type { SVGProps } from "react";
export interface CupcakeIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function CupcakeIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: CupcakeIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.64 12.884c.616.077 1.053.639.976 1.255l-.67 5.373a4.126 4.126 0 0 1-4.095 3.613H8.15a4.126 4.126 0 0 1-4.094-3.613l-.671-5.373-.009-.114a1.126 1.126 0 0 1 2.22-.278l.021.114.671 5.371a1.876 1.876 0 0 0 1.862 1.643h.533l-.31-6.824v-.116a1.125 1.125 0 0 1 2.236-.1l.01.114.317 6.926h2.13l.316-6.926a1.125 1.125 0 0 1 2.247.102l-.31 6.824h.533c.946 0 1.745-.704 1.862-1.643l.67-5.371a1.125 1.125 0 0 1 1.256-.977"
      />
      <path
        fill={color}
        d="M20.875 11.5c0-.76-.616-1.374-1.375-1.374H18a1.126 1.126 0 0 1-1.067-1.481c.31-.933.296-1.689.104-2.3-.194-.617-.596-1.174-1.197-1.654-.783-.626-1.87-1.089-3.109-1.343a2.55 2.55 0 0 1-.83 2.095c-.5.448-1.16.682-1.901.682H7.5c-.562 0-.875.14-1.04.262a.77.77 0 0 0-.297.473c-.096.45.118.975.462 1.204A1.125 1.125 0 0 1 6 10.126H4.5a1.375 1.375 0 1 0 0 2.749h15c.76 0 1.375-.616 1.375-1.376Zm2.25 0a3.625 3.625 0 0 1-3.625 3.625h-15a3.623 3.623 0 0 1-.51-7.211 3.4 3.4 0 0 1-.027-1.525 3.02 3.02 0 0 1 1.154-1.806c.632-.471 1.446-.708 2.383-.708H10c.258 0 .362-.074.396-.105a.3.3 0 0 0 .091-.197.47.47 0 0 0-.338-.504A1.126 1.126 0 0 1 10.5.875c2.474 0 5 .665 6.744 2.058.884.707 1.587 1.62 1.938 2.738a5.4 5.4 0 0 1 .208 2.204h.11a3.624 3.624 0 0 1 3.623 3.624Z"
      />
    </svg>
  );
}
